module.exports = __webpack_public_path__ + "static/img/top-corner.413dc818.svg";